<script>
import At from './At.vue'
import getCaretCoordinates from 'textarea-caret'
import { getAtAndIndex } from './util'

export default {
  extends: At,
  name: 'AtTextarea',
  data () {
    return {
     textValue:''
    }
  },
  computed: {
    style () {
      if (this.atwho) {
        //const {  x, y } = this.atwho
        const { wrap } = this.$refs
        const { chat_container_width } = this;
        //const el = this.$el.querySelector('textarea')
        if (wrap) {
          this.$nextTick(() => {
            let  atwho_view = wrap.getElementsByClassName('atwho-view')[0];
            atwho_view.style.width =  (chat_container_width - 20)+'px';
          });
          const left = '10px';//x + el.offsetLeft - el.scrollLeft + 'px'
          const bottom = '50px';// y + el.offsetTop - el.scrollTop + 'px'
          return { left, bottom }
        }
      }
      return null
    }
  },
  mounted(){
  },
  methods: {
    handleValueUpdate (value) {
      const el = this.$el.querySelector('textarea')
      if (value !== el.value) { // avoid range reset
        el.value = value
        this.dispatchInput()
      }
    },
    dispatchInput () {
      let el = this.$el.querySelector('textarea')
      let ev = new Event('input', { bubbles: true })
      el.dispatchEvent(ev)
    },

    handleDelete (deleteHandle) { 
      const el = this.$el.querySelector('textarea')
      const text = el.value.slice(0, el.selectionEnd)
      if (text) {
        const { atItems, members, suffix, deleteMatch, itemName } = this
        const { at, index } = getAtAndIndex(text, atItems)
        if (index > -1) {
          const chunk = text.slice(index + at.length)
          const has = members.some(v => {
            const name = itemName(v)
            if(name == chunk.trim()){
              this.$emit("at_delete_action", v);
            }
            
            if(deleteHandle){
              return deleteMatch(name, chunk, '')
            }
            else{
              return deleteMatch(name, chunk, suffix)
            }
          })
          if (has) {
            el.value = el.value.slice(0, index) +
            el.value.slice(el.selectionEnd - 0)
            el.selectionStart = index + 0;
            el.selectionEnd = index + 0;

            this.handleInput(false, false)
          }
        }
      }
    },

    handleInput (keep, deleteHandle=true) {
      if (this.hasComposition) return
      const el = this.$el.querySelector('textarea')
     
      const text = el.value.slice(0, el.selectionEnd)
      if(deleteHandle){
        let cur_text =  text;
        let positions = this.find_Entered_And_Removed_Substrings(
          this.textValue, cur_text, Math.max(
          el.selectionStart, el.selectionEnd)
        )
       
        if(positions.left == positions.right){
          this.handleDelete(deleteHandle);
        }
        this.textValue = cur_text
      }
     
      this.$emit('input', el.value)
      if (text) {
        const { atItems, avoidEmail, allowSpaces} = this
        let show = true
        const { at, index } = getAtAndIndex(text, atItems)
        
        if (index < 0) show = false
        const prev = text[index - 1]
        const chunk = text.slice(index + at.length, text.length)
        if (avoidEmail) {
          if (/^[a-z0-9]$/i.test(prev)) show = false
        }
        if (!allowSpaces && /\s/.test(chunk)) {
          show = false
        }

      
        if (/^\s/.test(chunk)) show = false
        if (!show) {
          this.closePanel()
        } else {
          const { members, filterMatch, itemName } = this
          if (!keep) { 
            this.$emit('at', chunk)
          }
          const matched = members.filter(v => {
            const name = itemName(v)
            return filterMatch(name, chunk, at)
          })
          if (matched.length) {
            this.openPanel(matched, chunk, index, at, keep)
          } else {
            this.closePanel()
          }
        }
      } else {
        this.closePanel()
      }
    },

    openPanel (list, chunk, offset, at) {
      const fn = () => {
        const el = this.$el.querySelector('textarea')
        const atEnd = offset + at.length 
        const rect = getCaretCoordinates(el, atEnd)
        this.atwho = {
          chunk,
          offset,
          list,
          atEnd,
          x: rect.left,
          y: rect.top - 4,
          cur: 0, 
        }
      }
      if (this.atwho) {
        fn()
      } else { 
        setTimeout(fn, 10)
      }
    },

   
    insertText (text, ta) { 
      const start = ta.selectionStart
      const end = ta.selectionEnd
      ta.value = ta.value.slice(0, start) +
      text + ta.value.slice(end)
      const newEnd = start + text.length
      ta.selectionStart = newEnd
      ta.selectionEnd = newEnd
      this.dispatchInput()
    },
    insertItem () {
      const {list, cur, atEnd } = this.atwho
      const { suffix, atItems, itemName } = this
      const el = this.$el.querySelector('textarea')
      const text = el.value.slice(0, atEnd)
      const { at, index } = getAtAndIndex(text, atItems)
      const start = index + at.length 
      el.selectionStart = start
      el.focus() // 
      const curItem = list[cur]
      const t = itemName(curItem) + suffix
      this.insertText(t, el)
      this.$emit('insert', curItem)
      this.handleInput(false, false)
    },
    find_Entered_And_Removed_Substrings(previous_string, current_string, pos) {
      let right_boundary_of_removed = previous_string.length - (current_string.length - pos),
      left_max_pos = Math.min(pos, right_boundary_of_removed),
      left_pos = left_max_pos

      for (let x = 0; x < left_max_pos; x++){
        if (previous_string[x] !== current_string[x]){
          left_pos = x
          break
        }
      }


      return {
        left: left_pos,
        right: pos,
        removed_left: left_pos,
        removed_right: right_boundary_of_removed
      }
    }
  }
}
</script>
